const hereApikey = 'Mfhi3jBkOKWwdRAFMmcZmUe-OcklGanO6bPUPxSpGEw';

export const environment = {
    production: true,
    accountRequestServiceUrl: 'https://account-request-service.supplystack.io',
    configurationServiceUrl: 'https://configuration-service.supplystack.io',
    devUrls: ['localhost:4200', 'cup.dev.supplystack.com'],
    loggedInRoute: 'dashboard',
    notFoundRoute: '404',
    recaptchaKey: '6LfPKCMTAAAAANNo4JR2eKRNP27jBWTPOOXGnuGR',
    sentryDNS: 'https://3ab60ed32c2f47e5a37a120407177b87@o375481.ingest.sentry.io/6193671',
    serverErrorRoute: '502',
    showDialogReport: false,
    showErrorOnConsole: true,
    tilesets: {
        roadmap: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=explore.day&apikey=${hereApikey}`,
        satellite: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=explore.satellite.day&apikey=${hereApikey}`,
        terrain: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=topo.day&apikey=${hereApikey}`,
    },
    umsFrameUrl: 'https://ums.operations.transporeon.com/frame-compact/index.html',
    umsLoginUrl: 'https://ums.operations.transporeon.com',
    umsProfileUrl: 'https://ums.operations.transporeon.com/profile',
    umsUrl: 'https://apigw.supplystack.com/ums',
    unauthorizedFoundRoute: '403',
    // check the non prod environment for a description of these fields
    localCTConfigurationServiceUrl: null,
    localCTPortalConfigNamePrefix: null,
};
